import { BbkCustomerDataLayer } from '../../../graphql/types/graphql'
import type { ExtendedCategoryDataLayer } from '../../../types/dataLayer'
import type { ProductBaseGtm } from '~/types/productBaseGtm'

type TypeProductClickEvent = {
    product: ReturnType<typeof getProductForGtm>
    [key: string]: unknown
}

export function useGtmCategory({ categoryName = '' }: { categoryName?: string } = {}) {
    const pageTypeEvent = (currentStore: string, customerData: BbkCustomerDataLayer, gaCookie: string) => {
        useGtm()?.trackEvent({
            currentStore,
            customerData,
            _ga: gaCookie || '',
        })
    }

    const fireRemarketingTagEvent = async () => {
        const { isUserLoggedIn } = useUser()
        useGtm()?.trackEvent({
            event: 'fireRemarketingTag',
            'google_tag_params.ecomm_pagetype': 'category',
            'google_tag_params.ecomm_category': categoryName,
            'google_tag_params.returnCustomer': await isUserLoggedIn(),
        })
    }

    const productClickEvent = ({ product, ...params }: TypeProductClickEvent) => {
        if ( params.additionalData ) {
            useGtm()?.trackEvent({
                event: 'productClick',
                ...params.additionalData,
                ecommerce: {
                    click: {
                        products: [product],
                    },
                },
            })
        } else {
            useGtm()?.trackEvent({
                event: 'productClick',
                ...params,
                ecommerce: {
                    click: {
                        products: [product],
                    },
                },
            })
        }

    }

    const categoryDataEvent = (dataLayer: ExtendedCategoryDataLayer, name: string) => {
        const { categoryUid, categoryLevel, categoryHierarchy, parentCategoryId } = dataLayer

        useGtm()?.trackEvent({
            categoryId: categoryUid,
            categoryLevel,
            categoryHierarchy,
            parentCategoryId,
            categoryName: name,
        })
    }

    const productsLoadedEvent = (products: ProductBaseGtm[]) => {
        useGtm()?.trackEvent({
            event: 'productsLoaded',
            ecommerce: {
                impressions: products,
            },
        })
    }

    const productsUpdateEvent = (products: ProductBaseGtm[]) => {
        useGtm()?.trackEvent({
            event: 'productsUpdated',
            ecommerce: {
                impressions: products,
            },
        })
    }

    return {
        categoryDataEvent,
        productClickEvent,
        pageTypeEvent,
        fireRemarketingTagEvent,
        productsLoadedEvent,
        productsUpdateEvent,
    }
}
